import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { ThemeProvider, createTheme } from '@material-ui/core/styles';

import { UseDarkTheme } from './model/constants'
import MainComponent from './components/mainComponents/MainComponent';
import AuthComponent from './components/mainComponents/AuthComponent';
import './App.css';


const theme = createTheme({
	palette: {
		type: !UseDarkTheme ? "light" : "dark",
    primary: {
      main:"#007ACC"
    }
	},
});

function App() {
 return (  
    <>  
      <ThemeProvider theme={theme}>
        <div className="App">
          <Routes>
            <Route exact path="/" element={<AuthComponent/>} />
            <Route path="/auth" element={<AuthComponent/>}/>
            <Route path="/info/*" element={<MainComponent/>} />    
         </Routes>
         </div>    
      </ThemeProvider>
    </>
  );
}

export default App;
